/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_9Inputs */

const en_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic and advanced Subtitle file export**`)
};

const fr_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de fichiers de sous-titres de base et avancés**`)
};

const de_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfacher und erweiterter Export von Untertiteldateien**`)
};

const it_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione di file di sottotitoli di base e avanzati**`)
};

const ru_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовый и расширенный экспорт файлов субтитров**`)
};

const es_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de archivos de subtítulos básica y avanzada**`)
};

const zh_cn2_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本和高级字幕文件导出**`)
};

const ja_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本および高度な字幕ファイルのエクスポート**`)
};

const hi_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुनियादी और उन्नत उपशीर्षक फ़ाइल निर्यात**`)
};

const pt_pt2_signup_feature_pro_9 = /** @type {(inputs: Signup_Feature_Pro_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação básica e avançada de arquivos de legenda**`)
};

/**
* | output |
* | --- |
* | "Basic and advanced Subtitle file export**" |
*
* @param {Signup_Feature_Pro_9Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_9 = /** @type {((inputs?: Signup_Feature_Pro_9Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_9Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_9(inputs)
	if (locale === "de") return de_signup_feature_pro_9(inputs)
	if (locale === "it") return it_signup_feature_pro_9(inputs)
	if (locale === "ru") return ru_signup_feature_pro_9(inputs)
	if (locale === "es") return es_signup_feature_pro_9(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_9(inputs)
	if (locale === "ja") return ja_signup_feature_pro_9(inputs)
	if (locale === "hi") return hi_signup_feature_pro_9(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_9(inputs)
	return en_signup_feature_pro_9(inputs)
});